import axios, { AxiosInstance } from 'axios';

import { handleMaintenanceMode } from './callApi';

const axiosInstance: AxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_SERVER_PATH,
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 503) {
      handleMaintenanceMode();
    }
    return Promise.reject(error);
  },
);

export default axiosInstance;
